export const STRIPE = 'stripe';
export const VENMO = 'venmo';

export const PAYMENT_METHODS = {
  STRIPE: {
    id: STRIPE,
    name: 'Accepted payment methods',
    description:
      'Guests will be charged a small processing fee for each gift purchased with a credit card. This payment method is required for all funds.',
    disabled: true,
  },
  VENMO: {
    id: VENMO,
    name: 'Venmo',
    description:
      'Guests have no-fee options and send cash directly to your Venmo account.',
  },
};
